(function () {
  const CG_TP_WIDGET_EVENT = "cg_trustpilot_widget";
  const CG_TP_GTMLOGGER_ENDPOINT_DEFAULT =
    "https://gtmlogger.cacaogenot.nl:8000/events";

  var _cachedReviewsStore;
  var _reviewsStoreParsed = false;
  var _widgetDataByKey = Object.create(null);
  var _widgetCssFetchByUrl = Object.create(null);
  var _gtmIds;

  function _safeJsonStringify(x) {
    try {
      return JSON.stringify(x);
    } catch (e) {
      return "";
    }
  }

  function _getCookieValue(name) {
    try {
      const cookies = document.cookie ? document.cookie.split("; ") : [];
      const prefix = name + "=";
      for (let i = 0; i < cookies.length; i++) {
        if (cookies[i].indexOf(prefix) === 0) {
          return decodeURIComponent(cookies[i].substring(prefix.length));
        }
      }
    } catch (e) {}
    return "";
  }

  function _ga4ClientIdFromGaCookie() {
    const gaCookie = _getCookieValue("_ga");
    if (!gaCookie) return "";
    const m = String(gaCookie).match(/^GA\d+\.\d+\.(\d+)\.(\d+)$/);
    if (!m) return "";
    return String(m[1]) + "." + String(m[2]);
  }

  function _generateClientId() {
    const left = String(Math.floor(Math.random() * 1e12));
    const right = String(Math.floor(Math.random() * 1e12));
    return left + "." + right;
  }

  function _ensureClientId() {
    const gaCid = _ga4ClientIdFromGaCookie();
    if (gaCid) return gaCid;
    const existing = _getCookieValue("cg_ga_cid");
    if (/^\d+\.\d+$/.test(existing || "")) return existing;
    const cid = _generateClientId();
    return cid;
  }

  function _ensureSessionId() {
    const existing = _getCookieValue("cg_ga_sid");
    if (/^\d+$/.test(existing || "")) return existing;
    return String(Math.floor(Date.now() / 1000));
  }

  function _ensureSessionNumber() {
    try {
      const v = window.sessionStorage
        ? window.sessionStorage.getItem("cg_session_number")
        : "";
      const n = Number(v);
      if (n >= 1 && isFinite(n)) return Math.floor(n);
      if (window.sessionStorage) window.sessionStorage.setItem("cg_session_number", "1");
    } catch (e) {}
    return 1;
  }

  function gtmIds() {
    if (!_gtmIds) {
      _gtmIds = {
        client_id: _ensureClientId(),
        session_id: _ensureSessionId(),
        session_number: _ensureSessionNumber(),
      };
    }
    return _gtmIds;
  }

  function sendToGtmLogger(action, detail) {
    try {
      // Opt-in/override via window of widget attribute; default is veilig voor productie.
      const endpoint =
        (window && window.CG_GTMLOGGER_ENDPOINT) ||
        CG_TP_GTMLOGGER_ENDPOINT_DEFAULT;
      if (!endpoint) return;

      const d = detail || {};
      const ids = gtmIds();
      const payload = {
        event_name: "trustpilot_widget_interaction",
        shopify_event_name: "trustpilot_widget_interaction",
        client_id: ids.client_id,
        session_id: ids.session_id,
        session_number: ids.session_number,
        page_location:
          (window.location && window.location.href) ? window.location.href : "",
        tpw_action: action,
        tpw_target: d.target,
        tpw_company_slug: d.company_slug,
        tpw_company_url: d.company_url,
        tpw_review_id: d.review_id,
        tpw_review_user_url: d.review_user_url,
        tpw_format: d.format,
        tpw_direction: d.direction,
        tpw_from_index: d.from_index,
        tpw_to_index: d.to_index,
        tpw_index: d.index,
        tpw_from_scroll_left: d.from_scroll_left,
      };

      // Fire-and-forget: keepalive waar beschikbaar
      if (typeof fetch === "function") {
        fetch(endpoint, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: _safeJsonStringify(payload),
          keepalive: true,
          credentials: "omit",
        }).catch(function () {});
      }
    } catch (e) {}
  }

  function emitWidgetEvent(action, detail) {
    try {
      const payload = Object.assign({ action: action }, detail || {});
      window.dispatchEvent(new CustomEvent(CG_TP_WIDGET_EVENT, { detail: payload }));
    } catch (e) {}

    // Fallback: als Shopify pixel het window-event niet kan horen, log direct.
    sendToGtmLogger(action, detail);
  }

  function detectLangFromPath() {
    const p = (window.location.pathname || "").toLowerCase();
    if (p.startsWith("/en/") || p.startsWith("/en-")) return "en";
    if (p.startsWith("/fr/") || p.startsWith("/fr-")) return "fr";
    if (p.startsWith("/de/") || p.startsWith("/de-")) return "de";
    if (p.startsWith("/it/") || p.startsWith("/it-")) return "it";
    if (p.startsWith("/es/") || p.startsWith("/es-")) return "es";
    if (p.startsWith("/nl/") || p.startsWith("/nl-")) return "nl";
    return "nl";
  }

  function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
  }

  function resolveTrustpilotStarGlyphUrl(ratingStarSrc) {
    var src = String(ratingStarSrc || "").trim();
    if (!src) return "";
    if (src.indexOf("trustpilot-rating-star.png") >= 0) {
      return src.replace(
        /trustpilot-rating-star\.png(\?.*)?$/i,
        "trustpilot-rating-star-glyph.png$1"
      );
    }
    if (src.indexOf("trustpilot-star.png") >= 0) {
      return src.replace(/trustpilot-star\.png(\?.*)?$/i, "trustpilot-rating-star-glyph.png$1");
    }
    return src.replace(/(\?.*)?$/, function (q) {
      return (q ? q + "&" : "?") + "glyph=1";
    });
  }

  function appendTrustpilotStarBlock(container, fill, starSrc, glyphSrc) {
    var s = document.createElement("span");
    s.className = "tp-star tp-star-block";
    if (fill >= 0.999) s.classList.add("is-full");
    else if (fill <= 0.001) s.classList.add("is-empty");
    s.style.setProperty("--tp-fill", fill.toFixed(4));
    s.setAttribute("aria-hidden", "true");

    if (fill >= 0.999) {
      var fullImg = document.createElement("img");
      fullImg.className = "tp-star-img";
      fullImg.src = starSrc;
      fullImg.alt = "";
      fullImg.decoding = "async";
      fullImg.loading = "lazy";
      s.appendChild(fullImg);
    } else {
      var bg = document.createElement("span");
      bg.className = "tp-star-bg";
      s.appendChild(bg);
      var glyph = document.createElement("img");
      glyph.className = "tp-star-glyph";
      glyph.src = glyphSrc || starSrc;
      glyph.alt = "";
      glyph.decoding = "async";
      glyph.loading = "lazy";
      s.appendChild(glyph);
    }
    container.appendChild(s);
  }

  function starElements(rating, opts) {
    opts = opts || {};
    var starSrc = opts.starSrc || "";
    var glyphSrc = opts.glyphSrc || resolveTrustpilotStarGlyphUrl(starSrc);
    var fractional = !!opts.fractional;
    var r = clamp(Number(rating || 0), 0, 5);
    var container = document.createElement("div");
    container.className = "tp-stars";

    if (starSrc) {
      container.classList.add("tp-stars-tp");
      if (fractional) container.classList.add("tp-stars-fractional");
      for (var i = 1; i <= 5; i++) {
        var fill = fractional ? clamp(r - (i - 1), 0, 1) : i <= Math.round(r) ? 1 : 0;
        appendTrustpilotStarBlock(container, fill, starSrc, glyphSrc);
      }
      return container;
    }

    if (fractional) {
      container.classList.add("tp-stars-fractional");
      for (var j = 1; j <= 5; j++) {
        var fillF = clamp(r - (j - 1), 0, 1);
        var s = document.createElement("span");
        s.className = "tp-star tp-star-block";
        s.style.setProperty("--tp-fill", fillF.toFixed(4));
        s.textContent = "★";
        s.setAttribute("aria-hidden", "true");
        container.appendChild(s);
      }
      return container;
    }

    var full = Math.round(r);
    for (var k = 1; k <= 5; k++) {
      var s2 = document.createElement("span");
      s2.className = "tp-star " + (k <= full ? "full" : "empty");
      s2.textContent = "★";
      container.appendChild(s2);
    }
    return container;
  }

  function widgetAssetUrl(assetBase, file) {
    var base = String(assetBase || (typeof window !== "undefined" ? window.location.origin : "")).replace(
      /\/$/,
      ""
    );
    return base + "/widget/" + file;
  }

  function resolveTrustpilotStarUrl(widgetEl, scriptOrigin) {
    if (typeof window !== "undefined" && window.__BONBON_TRUSTPILOT_STAR_URL__) {
      return String(window.__BONBON_TRUSTPILOT_STAR_URL__);
    }
    if (widgetEl) {
      var direct = (widgetEl.getAttribute("data-trustpilot-star-url") || "").trim();
      if (direct) return direct;
      var source = (widgetEl.getAttribute("data-source") || "").toLowerCase();
      if (source === "local" || source === "shopify") {
        var script = document.querySelector('script[data-tp-widget-src="true"]');
        if (script && script.src) {
          try {
            var su = new URL(script.src);
            if (/\/assets\/widget\.js/i.test(su.pathname)) {
              return su.href.replace(/widget\.js(\?.*)?$/i, "trustpilot-star.png");
            }
          } catch (eScript) {}
        }
      }
    }
    var api = widgetEl
      ? String(widgetEl.getAttribute("data-api-base") || "")
          .replace(/\/$/, "")
          .trim()
      : "";
    if (api && /^https?:\/\//i.test(api)) return widgetAssetUrl(api, "trustpilot-star.png");
    if (scriptOrigin && /^https?:\/\//i.test(scriptOrigin) && scriptOrigin.indexOf("myshopify.com") === -1) {
      return widgetAssetUrl(scriptOrigin, "trustpilot-star.png");
    }
    return "";
  }

  /** Groen blok-ster voor review-scores (niet het Trustpilot-logo). */
  function resolveTrustpilotRatingStarUrl(widgetEl, scriptOrigin) {
    if (typeof window !== "undefined" && window.__BONBON_TRUSTPILOT_RATING_STAR_URL__) {
      return String(window.__BONBON_TRUSTPILOT_RATING_STAR_URL__);
    }
    if (widgetEl) {
      var direct = (widgetEl.getAttribute("data-trustpilot-rating-star-url") || "").trim();
      if (direct) return direct;
      var brand = resolveTrustpilotStarUrl(widgetEl, scriptOrigin);
      if (brand && /trustpilot-star\.png/i.test(brand)) {
        return brand.replace(/trustpilot-star\.png(\?.*)?$/i, "trustpilot-rating-star.png$1");
      }
      var source = (widgetEl.getAttribute("data-source") || "").toLowerCase();
      if (source === "local" || source === "shopify") {
        var script = document.querySelector('script[data-tp-widget-src="true"]');
        if (script && script.src) {
          try {
            var su = new URL(script.src);
            if (/\/assets\/widget\.js/i.test(su.pathname)) {
              return su.href.replace(/widget\.js(\?.*)?$/i, "trustpilot-rating-star.png");
            }
          } catch (eScript2) {}
        }
      }
    }
    var api = widgetEl
      ? String(widgetEl.getAttribute("data-api-base") || "")
          .replace(/\/$/, "")
          .trim()
      : "";
    if (api && /^https?:\/\//i.test(api)) return widgetAssetUrl(api, "trustpilot-rating-star.png");
    if (scriptOrigin && /^https?:\/\//i.test(scriptOrigin) && scriptOrigin.indexOf("myshopify.com") === -1) {
      return widgetAssetUrl(scriptOrigin, "trustpilot-rating-star.png");
    }
    return "";
  }

  /** Officieel Trustpilot-logo (gevouwen groene ster). */
  function trustpilotBrandMarkHtml(className, starSrc, sizePx) {
    var px = sizePx == null ? 20 : sizePx;
    var src = starSrc || "";
    return (
      '<span class="' + className + '" aria-hidden="true">' +
      '<img src="' + src + '" alt="" width="' + px + '" height="' + px + '" decoding="async" loading="lazy" />' +
      "</span>"
    );
  }

  function ratingLabel(avgRating, lang) {
    const r = Number(avgRating || 0);
    const L = String(lang || "en").toLowerCase();
    // Minimal mapping; keeps UI close to Trustpilot wording.
    const t =
      r >= 4.5 ? { en: "Excellent", nl: "Uitstekend", es: "Excelente" } :
      r >= 4.0 ? { en: "Great", nl: "Geweldig", es: "Muy bien" } :
      r >= 3.0 ? { en: "Average", nl: "Gemiddeld", es: "Promedio" } :
      r >= 2.0 ? { en: "Poor", nl: "Matig", es: "Bajo" } :
      { en: "Bad", nl: "Slecht", es: "Malo" };
    return (t[L] || t.en);
  }

  function basedOnReviewsText(count, lang, short) {
    const n = Number(count) || 0;
    const L = String(lang || "en").toLowerCase();
    if (short) {
      const compact = {
        en: n + " reviews",
        nl: n + " reviews",
        de: n + " Bewertungen",
        fr: n + " avis",
        it: n + " recensioni",
        es: n + " reseñas",
      };
      return compact[L] || compact.en;
    }
    const templates = {
      en: "Based on " + n + " reviews",
      nl: "Gebaseerd op " + n + " reviews",
      de: "Basierend auf " + n + " Bewertungen",
      fr: "Basé sur " + n + " avis",
      it: "Basato su " + n + " recensioni",
      es: "Basado en " + n + " reseñas",
    };
    return templates[L] || templates.en;
  }

  function format4ReviewsCompact() {
    try {
      return window.matchMedia("(max-width: 749px)").matches;
    } catch (e) {
      return false;
    }
  }

  function verifiedPill(verified) {
    if (!verified) return null;
    const el = document.createElement("span");
    el.className = "tp-verified";
    el.textContent = "Verified";
    return el;
  }

  function truncateText(s, max) {
    s = String(s || "")
      .replace(/\s+/g, " ")
      .trim();
    if (s.length <= max) return s;
    return s.slice(0, max - 1).trim() + "…";
  }

  /** Taalcode → ISO-landcode voor vlag (Engels = GB, Spaans = ES). */
  function langPrimaryCountry(langCode) {
    var c = String(langCode || "nl").toLowerCase().trim();
    var map = {
      nl: "nl",
      en: "gb",
      de: "de",
      fr: "fr",
      it: "it",
      es: "es",
      pt: "br",
      pl: "pl",
      tr: "tr",
      ar: "sa",
      zh: "cn",
      ja: "jp",
      ko: "kr",
      hi: "in",
      sv: "se",
      da: "dk",
      nb: "no",
      no: "no",
      fi: "fi",
    };
    return map[c] || "";
  }

  function parseFlagUrls(widgetEl) {
    if (typeof window !== "undefined" && window.__BONBON_TP_FLAG_URLS__) {
      return window.__BONBON_TP_FLAG_URLS__;
    }
    if (!widgetEl) return {};
    var raw = widgetEl.getAttribute("data-flag-urls");
    if (!raw) return {};
    try {
      return JSON.parse(raw);
    } catch (e) {
      return {};
    }
  }

  function resolveFlagUrls(el) {
    if (typeof window !== "undefined" && window.__BONBON_TP_FLAG_URLS__) {
      return window.__BONBON_TP_FLAG_URLS__;
    }
    try {
      var root = el && el.getRootNode ? el.getRootNode() : null;
      if (root && root.host && root.host.__tpFlagUrls) return root.host.__tpFlagUrls;
    } catch (eRoot) {}
    var host = document.querySelector("[data-tp-widget]");
    return (host && host.__tpFlagUrls) || {};
  }

  function setLangFlagButton(btn, langCode, flagUrls) {
    if (!btn) return;
    var cc = langPrimaryCountry(langCode);
    var urls = flagUrls || {};
    var img = btn.querySelector("img.tp-flag-img");
    btn.textContent = "";
    if (!cc || !urls[cc]) {
      btn.removeAttribute("data-flag");
      if (img) img.remove();
      return;
    }
    btn.setAttribute("data-flag", cc);
    if (!img) {
      img = document.createElement("img");
      img.className = "tp-flag-img";
      img.alt = "";
      img.width = 22;
      img.height = 16;
      img.decoding = "async";
      img.loading = "lazy";
      btn.appendChild(img);
    }
    if (img.getAttribute("src") !== urls[cc]) {
      img.src = urls[cc];
    }
  }

  function reviewLangHasFlag(r) {
    if (!r) return false;
    return !!langPrimaryCountry(String(r.source_lang || "nl"));
  }

  function reviewLangCanToggle(r, displayLang) {
    if (!r) return false;
    var src = String(r.source_lang || "nl").toLowerCase();
    var disp = String(displayLang || "nl").toLowerCase();
    if (src !== disp) return true;
    var titleDisp = String(r.title || "");
    var bodyDisp = String(r.body || "");
    var titleSrc = r.title_source != null ? String(r.title_source) : titleDisp;
    var bodySrc = r.body_source != null ? String(r.body_source) : bodyDisp;
    return titleDisp !== titleSrc || bodyDisp !== bodySrc;
  }

  /** Vlag rechtsboven: wissel tussen vertaling (shop-taal) en brontaal. */
  function setupReviewLangToggle(rootEl, getReview, displayLang, titleEl, bodyEl, bodyTruncate, assetBase) {
    if (!rootEl) return { refresh: function () {}, reset: function () {} };
    var state = { showingSource: false };
    var btn = rootEl.querySelector(".tp-review-lang-flag");
    if (!btn) {
      btn = document.createElement("button");
      btn.type = "button";
      btn.className = "tp-review-lang-flag";
      btn.addEventListener("click", function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        ev.stopImmediatePropagation();
        if (!reviewLangCanToggle(getReview() || {}, displayLang)) return;
        state.showingSource = !state.showingSource;
        apply();
      });
      rootEl.appendChild(btn);
    }

    function apply() {
      var r = getReview() || {};
      var src = String(r.source_lang || "nl").toLowerCase();
      var disp = String(displayLang || "nl").toLowerCase();
      var titleDisp = String(r.title || "");
      var bodyDisp = String(r.body || "");
      var titleSrc = r.title_source != null ? String(r.title_source) : titleDisp;
      var bodySrc = r.body_source != null ? String(r.body_source) : bodyDisp;
      var hasFlag = reviewLangHasFlag(r);
      var canToggle = reviewLangCanToggle(r, displayLang);

      btn.style.display = hasFlag ? "inline-flex" : "none";
      btn.classList.toggle("tp-review-lang-flag-static", hasFlag && !canToggle);
      btn.disabled = !canToggle;

      if (!hasFlag) {
        state.showingSource = false;
        if (titleEl) titleEl.textContent = titleDisp;
        if (bodyEl) {
          var bd0 = bodyTruncate ? truncateText(bodyDisp, bodyTruncate) : bodyDisp;
          bodyEl.textContent = bd0;
          bodyEl.style.display = bd0 ? "" : "none";
        }
        return;
      }

      if (!canToggle) state.showingSource = false;

      var title = state.showingSource && canToggle ? titleSrc : titleDisp;
      var body = state.showingSource && canToggle ? bodySrc : bodyDisp;
      if (titleEl) titleEl.textContent = title;
      if (bodyEl) {
        var bt = bodyTruncate ? truncateText(body, bodyTruncate) : body;
        bodyEl.textContent = bt;
        bodyEl.style.display = bt ? "" : "none";
      }

      /* Standaard: brontaal op de vlag; bij wisselen tonen we de andere taal. */
      setLangFlagButton(btn, state.showingSource && canToggle ? disp : src, resolveFlagUrls(rootEl));
      btn.setAttribute("aria-pressed", canToggle && state.showingSource ? "true" : "false");
      if (!canToggle) {
        btn.setAttribute("aria-label", "Brontaal (" + src.toUpperCase() + ")");
        btn.title = "Brontaal (" + src.toUpperCase() + ")";
      } else {
        btn.setAttribute(
          "aria-label",
          state.showingSource
            ? "Toon vertaling (" + disp.toUpperCase() + ")"
            : "Toon originele review (" + src.toUpperCase() + ")"
        );
        btn.title = state.showingSource
          ? "Vertaling (" + disp.toUpperCase() + ")"
          : "Origineel (" + src.toUpperCase() + ")";
      }
    }

    function reset() {
      state.showingSource = false;
      apply();
    }

    apply();

    return {
      refresh: apply,
      reset: reset,
    };
  }

  function formatReviewDate(isoStr, lang) {
    if (!isoStr) return "";
    const d = new Date(isoStr);
    if (isNaN(d.getTime())) return isoStr;
    const now = new Date();
    const diffDays = Math.floor((now.getTime() - d.getTime()) / 86400000);
    const L = (lang || "nl").toLowerCase();
    if (L === "nl") {
      if (diffDays === 0) return "vandaag";
      if (diffDays === 1) return "gisteren";
      if (diffDays > 1 && diffDays <= 7) return diffDays + " dagen geleden";
    }
    if (L === "es") {
      if (diffDays === 0) return "hoy";
      if (diffDays === 1) return "ayer";
      if (diffDays > 1 && diffDays <= 7) return "hace " + diffDays + " días";
    }
    var locale =
      L === "de"
        ? "de-DE"
        : L === "fr"
          ? "fr-FR"
          : L === "it"
            ? "it-IT"
            : L === "es"
              ? "es-ES"
            : L === "en"
              ? "en-GB"
              : "nl-NL";
    try {
      return new Intl.DateTimeFormat(locale, {
        day: "numeric",
        month: "short",
        year: "numeric",
      }).format(d);
    } catch (e) {
      return d.toLocaleDateString();
    }
  }

  function bindNavPointer(el, handler) {
    el.addEventListener(
      "pointerdown",
      function (ev) {
        if (ev.button !== 0) return;
        ev.preventDefault();
        ev.stopImmediatePropagation();
        ev.stopPropagation();
        handler(ev);
      },
      { capture: true, passive: false }
    );
  }

  function trustpilotReviewUrl(companyOrSlug) {
    var slug = "";
    if (companyOrSlug && typeof companyOrSlug === "object") {
      slug = String(
        companyOrSlug.trustpilot_review_slug || companyOrSlug.slug || ""
      ).trim();
    } else {
      slug = String(companyOrSlug || "").trim();
    }
    if (!slug) return "https://nl.trustpilot.com/";
    return "https://nl.trustpilot.com/review/" + encodeURIComponent(slug);
  }

  function linkEl(href, text, extraClass) {
    const a = document.createElement("a");
    a.href = href;
    a.target = "_blank";
    a.rel = "noopener noreferrer";
    a.className = extraClass || "";
    a.textContent = text;
    return a;
  }

  function appendAvgScoreRow(parent, avgRating, extraScoreClass) {
    if (avgRating == null || avgRating === "") return;
    const n = Number(avgRating);
    if (isNaN(n)) return;
    const score = document.createElement("div");
    score.className = "tp-score" + (extraScoreClass ? " " + extraScoreClass : "");
    score.textContent = n.toFixed(1);
    score.setAttribute("aria-label", "Gemiddelde score " + score.textContent);
    parent.appendChild(score);
  }

  function renderFormat2(data, container, ratingStarSrc) {
    const company = data.company || {};
    const avg = data.avg_rating != null ? data.avg_rating : null;
    const companyUrl = trustpilotReviewUrl(company);

    container.innerHTML = "";
    const card = document.createElement("div");
    card.className = "tp-card";

    const top = document.createElement("div");
    top.className = "tp-top";

    const left = document.createElement("div");
    left.className = "tp-top-left";
    const stack = document.createElement("div");
    stack.className = "tp-headline-stack";
    const excellent = document.createElement("div");
    excellent.className = "tp-excellent";
    excellent.textContent = "EXCELLENT";
    stack.appendChild(excellent);
    left.appendChild(stack);

    const starsScore = document.createElement("div");
    starsScore.className = "tp-stars-score-row";
    starsScore.appendChild(starElements(avg || 5, { starSrc: ratingStarSrc }));
    appendAvgScoreRow(starsScore, avg);
    left.appendChild(starsScore);
    top.appendChild(left);

    const verified = verifiedPill(true);
    if (verified) top.appendChild(verified);
    card.appendChild(top);

    const sub = document.createElement("div");
    sub.className = "tp-sub";
    sub.appendChild(
      linkEl(
        companyUrl,
        "Based on " + (company.review_count || 0) + " reviews",
        "tp-link"
      )
    );
    card.appendChild(sub);

    // Maak het bovenblokje (rating/sterren + subregel) klikbaar
    top.classList.add("tp-clickable");
    sub.classList.add("tp-clickable");
    top.addEventListener("click", function () {
      emitWidgetEvent("click_trustpilot", {
        target: "company",
        company_slug: company.slug || "",
        company_url: companyUrl,
        format: 2,
      });
      window.open(companyUrl, "_blank", "noopener");
    });
    sub.addEventListener("click", function () {
      emitWidgetEvent("click_trustpilot", {
        target: "company",
        company_slug: company.slug || "",
        company_url: companyUrl,
        format: 2,
      });
      window.open(companyUrl, "_blank", "noopener");
    });

    container.appendChild(card);
  }

  /** Formaat 4: horizontale banner (logo, score, label, reviewtelling). */
  function renderFormat4(data, container, brandStarSrc, ratingStarSrc) {
    const company = data.company || {};
    const lang = String(data.lang || "nl").toLowerCase();
    const avg = data.avg_rating != null ? Number(data.avg_rating) : null;
    const count = company.review_count != null ? company.review_count : 0;
    const companyUrl = trustpilotReviewUrl(company);

    container.innerHTML = "";
    container.classList.add("tp-widget-format4");
    const banner = document.createElement("a");
    banner.className = "tp-format4-banner tp-card-link tp-clickable";
    banner.href = companyUrl;
    banner.target = "_blank";
    banner.rel = "noopener noreferrer";
    banner.setAttribute(
      "aria-label",
      "Trustpilot " +
        (avg != null && !isNaN(avg) ? avg.toFixed(1) : "") +
        " " +
        ratingLabel(avg || 5, lang)
    );
    banner.addEventListener("click", function () {
      emitWidgetEvent("click_trustpilot", {
        target: "company",
        company_slug: company.slug || "",
        company_url: companyUrl,
        format: 4,
      });
    });

    const logo = document.createElement("span");
    logo.className = "tp-format4-logo";
    logo.innerHTML =
      trustpilotBrandMarkHtml("tp-format4-mark", brandStarSrc, 20) +
      '<span class="tp-format4-name">Trustpilot</span>';
    banner.appendChild(logo);

    if (avg != null && !isNaN(avg)) {
      const score = document.createElement("span");
      score.className = "tp-format4-score";
      score.textContent = avg.toFixed(1);
      banner.appendChild(score);
    }

    const label = document.createElement("span");
    label.className = "tp-format4-label";
    label.textContent = ratingLabel(avg || 5, lang);
    banner.appendChild(label);

    const reviews = document.createElement("span");
    reviews.className = "tp-format4-reviews";
    function paintReviewsText() {
      reviews.textContent = basedOnReviewsText(count, lang, format4ReviewsCompact());
    }
    paintReviewsText();
    banner.appendChild(reviews);

    container.appendChild(banner);

    if (typeof window !== "undefined" && window.matchMedia) {
      var mq = window.matchMedia("(max-width: 749px)");
      function onMq() {
        paintReviewsText();
      }
      if (typeof mq.addEventListener === "function") {
        mq.addEventListener("change", onMq);
      } else if (typeof mq.addListener === "function") {
        mq.addListener(onMq);
      }
    }
  }

  function renderFormat3(data, container, brandStarSrc, ratingStarSrc) {
    const reviews = data.reviews || [];
    const company = data.company || {};
    const avg = data.avg_rating != null ? data.avg_rating : 5;
    const lang = String(data.lang || "nl").toLowerCase();
    const count = company.review_count != null ? company.review_count : reviews.length;
    const companyUrl = trustpilotReviewUrl(company);

    container.innerHTML = "";
    container.classList.add("tp-widget-format3");
    const card = document.createElement("div");
    card.className = "tp-card tp-format-3";

    const inner = document.createElement("div");
    inner.className = "tp-format3-inner";

    const topRow = document.createElement("div");
    topRow.className = "tp-format3-top";

    const summary = document.createElement("div");
    summary.className = "tp-format3-summary";

    const headline = document.createElement("div");
    headline.className = "tp-format3-headline";
    const ex = document.createElement("div");
    ex.className = "tp-excellent";
    ex.textContent = ratingLabel(avg, lang);
    headline.appendChild(ex);
    summary.appendChild(headline);

    const ratingRow = document.createElement("div");
    ratingRow.className = "tp-format3-rating-row";
    const avgStars = starElements(avg, { fractional: true, starSrc: ratingStarSrc });
    avgStars.classList.add("tp-stars-lg");
    ratingRow.appendChild(avgStars);
    appendAvgScoreRow(ratingRow, data.avg_rating, "tp-score-after-stars");
    if (data.avg_rating != null && !isNaN(Number(data.avg_rating))) {
      ratingRow.setAttribute(
        "aria-label",
        "Score " + Number(data.avg_rating).toFixed(1) + " van 5"
      );
    }
    summary.appendChild(ratingRow);

    var basedOnText = "Based on " + count + " reviews";

    const subDesktop = document.createElement("div");
    subDesktop.className = "tp-format3-sub tp-format3-meta-desktop";
    subDesktop.appendChild(linkEl(companyUrl, basedOnText, "tp-link"));

    const brandDesktop = document.createElement("div");
    brandDesktop.className = "tp-format3-brand tp-format3-meta-desktop";
    brandDesktop.innerHTML =
      trustpilotBrandMarkHtml("tp-format3-brand-mark", brandStarSrc, 18) + " Trustpilot";

    summary.appendChild(subDesktop);
    summary.appendChild(brandDesktop);

    const subMobile = document.createElement("div");
    subMobile.className = "tp-format3-sub tp-format3-meta-mobile";
    subMobile.appendChild(linkEl(companyUrl, basedOnText, "tp-link"));

    const brandMobile = document.createElement("div");
    brandMobile.className = "tp-format3-brand tp-format3-meta-mobile";
    brandMobile.innerHTML =
      trustpilotBrandMarkHtml("tp-format3-brand-mark", brandStarSrc, 18) + " Trustpilot";

    const footer = document.createElement("div");
    footer.className = "tp-format3-footer";
    footer.appendChild(subMobile);
    footer.appendChild(brandMobile);

    const main = document.createElement("div");
    main.className = "tp-format3-main";

    const navLeft = document.createElement("button");
    navLeft.type = "button";
    navLeft.className = "tp-nav";
    navLeft.setAttribute("aria-label", "Vorige reviews");
    navLeft.textContent = "‹";

    const navRight = document.createElement("button");
    navRight.type = "button";
    navRight.className = "tp-nav";
    navRight.setAttribute("aria-label", "Volgende reviews");
    navRight.textContent = "›";

    const viewport = document.createElement("div");
    viewport.className = "tp-format3-viewport";
    viewport.setAttribute("tabindex", "0");

    const track = document.createElement("div");
    track.className = "tp-format3-track";

    function applyFormat3Cols() {
      var mobile = window.matchMedia("(max-width: 900px)").matches;
      var cols = mobile ? 1 : Math.min(4, Math.max(1, reviews.length));
      track.style.setProperty("--tp-f3-cols", String(cols));
    }
    applyFormat3Cols();
    var f3Mq = window.matchMedia("(max-width: 900px)");
    if (f3Mq.addEventListener) {
      f3Mq.addEventListener("change", applyFormat3Cols);
    } else if (f3Mq.addListener) {
      f3Mq.addListener(applyFormat3Cols);
    }

    var trackFrag = document.createDocumentFragment();
    reviews.forEach(function (r) {
      trackFrag.appendChild(buildFormat3Card(r, data, lang, ratingStarSrc));
    });
    track.appendChild(trackFrag);

    viewport.appendChild(track);

    /** Eén kaart tegelijk; aan begin/einde “rond” naar het andere uiteinde. */
    function scrollStrip(dir) {
      var c = track.querySelector(".tp-format3-card");
      if (!c) return;
      var gap = 12;
      var step = c.offsetWidth + gap;
      if (step <= gap) return;
      var maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      if (maxScroll <= 0) return;
      var eps = 3;
      var sl = viewport.scrollLeft;
      emitWidgetEvent("browse_review", {
        company_slug: company.slug || "",
        format: 3,
        direction: dir < 0 ? "prev" : "next",
        from_scroll_left: sl,
      });
      if (dir < 0) {
        if (sl <= eps) {
          viewport.scrollTo({ left: maxScroll, behavior: "smooth" });
        } else {
          viewport.scrollTo({ left: Math.max(0, sl - step), behavior: "smooth" });
        }
      } else {
        if (sl >= maxScroll - eps) {
          viewport.scrollTo({ left: 0, behavior: "smooth" });
        } else {
          viewport.scrollTo({ left: Math.min(maxScroll, sl + step), behavior: "smooth" });
        }
      }
    }

    bindNavPointer(navLeft, function () {
      scrollStrip(-1);
    });
    bindNavPointer(navRight, function () {
      scrollStrip(1);
    });

    main.appendChild(navLeft);
    main.appendChild(viewport);
    main.appendChild(navRight);

    // Maak het eerste blokje (summary links) klikbaar
    summary.classList.add("tp-clickable");
    summary.addEventListener("click", function (ev) {
      const tag = (ev.target && ev.target.tagName) || "";
      if (String(tag).toLowerCase() === "a") return;
      emitWidgetEvent("click_trustpilot", {
        target: "company",
        company_slug: company.slug || "",
        company_url: companyUrl,
        format: 3,
      });
      window.open(companyUrl, "_blank", "noopener");
    });

    topRow.appendChild(summary);
    topRow.appendChild(main);
    inner.appendChild(topRow);
    inner.appendChild(footer);
    card.appendChild(inner);
    container.appendChild(card);
  }

  function buildFormat3Card(r, data, lang, ratingStarSrc) {
    var href = r && r.user_url;

    // Alleen klikbaar als er een user_url is (geen fallback).
    var el = document.createElement(href ? "a" : "article");
    el.className =
      "tp-format3-card tp-review-lang-host" + (href ? " tp-clickable tp-card-link" : "");
    if (href) {
      el.href = href;
      el.target = "_blank";
      el.rel = "noopener noreferrer";
    }
    el.addEventListener("click", function () {
      try {
        if (!href) return;
        const company = (data && data.company) || {};
        emitWidgetEvent("click_trustpilot", {
          target: "review",
          company_slug: company.slug || "",
          review_id: r && r.id ? r.id : "",
          review_user_url: href || "",
          format: 3,
        });
      } catch (e) {}
    });

    var head = document.createElement("div");
    head.className = "tp-format3-card-head";
    var sm = starElements(r.rating != null ? r.rating : data.avg_rating || 5, { starSrc: ratingStarSrc });
    sm.classList.add("tp-stars-f3");
    head.appendChild(sm);
    var pill = verifiedPill(r.verified);
    if (pill) head.appendChild(pill);

    var title = document.createElement("div");
    title.className = "tp-format3-card-title";
    title.textContent = r.title || "";

    var bodyEl = document.createElement("p");
    bodyEl.className = "tp-format3-card-body";
    bodyEl.textContent = truncateText(r.body || "", 180);
    if (!bodyEl.textContent) bodyEl.style.display = "none";

    var foot = document.createElement("div");
    foot.className = "tp-format3-card-foot";
    var namePart = (r.author || "").trim();
    var datePart = formatReviewDate(r.date, lang);
    foot.textContent =
      namePart + (namePart && datePart ? ", " : "") + (datePart || "");

    el.appendChild(head);
    el.appendChild(title);
    el.appendChild(bodyEl);
    el.appendChild(foot);

    setupReviewLangToggle(
      el,
      function () {
        return r;
      },
      lang,
      title,
      bodyEl,
      180,
      ratingStarSrc
    );

    return el;
  }

  function renderReviewCarousel(data, container, ratingStarSrc) {
    const reviews = data.reviews || [];
    const company = data.company || {};
    const lang = String(data.lang || "nl").toLowerCase();
    const companyUrl = trustpilotReviewUrl(company);

    container.innerHTML = "";
    const card = document.createElement("div");
    card.className = "tp-card tp-format-1";

    const top = document.createElement("div");
    top.className = "tp-top";

    const stack = document.createElement("div");
    stack.className = "tp-headline-stack tp-headline-stack-carousel";
    const excellent = document.createElement("div");
    excellent.className = "tp-excellent";
    excellent.textContent = "EXCELLENT";
    stack.appendChild(excellent);
    top.appendChild(stack);

    const starsScore = document.createElement("div");
    starsScore.className = "tp-stars-score-row";
    starsScore.appendChild(starElements(data.avg_rating || 5, { starSrc: ratingStarSrc }));
    appendAvgScoreRow(starsScore, data.avg_rating);
    top.appendChild(starsScore);

    card.appendChild(top);

    const sub = document.createElement("div");
    sub.className = "tp-sub";
    sub.appendChild(
      linkEl(
        companyUrl,
        "Based on " + (company.review_count || 0) + " reviews",
        "tp-link"
      )
    );
    card.appendChild(sub);

    // Klikbaar bovenblokje (top + sub), maar niet de carousel-buttons
    top.classList.add("tp-clickable");
    sub.classList.add("tp-clickable");
    top.addEventListener("click", function () {
      emitWidgetEvent("click_trustpilot", {
        target: "company",
        company_slug: company.slug || "",
        company_url: companyUrl,
        format: 1,
      });
      window.open(companyUrl, "_blank", "noopener");
    });
    sub.addEventListener("click", function () {
      emitWidgetEvent("click_trustpilot", {
        target: "company",
        company_slug: company.slug || "",
        company_url: companyUrl,
        format: 1,
      });
      window.open(companyUrl, "_blank", "noopener");
    });

    const carousel = document.createElement("div");
    carousel.className = "tp-carousel";

    const navLeft = document.createElement("button");
    navLeft.type = "button";
    navLeft.className = "tp-nav";
    navLeft.setAttribute("aria-label", "Vorige review");
    navLeft.textContent = "‹";

    const navRight = document.createElement("button");
    navRight.type = "button";
    navRight.className = "tp-nav";
    navRight.setAttribute("aria-label", "Volgende review");
    navRight.textContent = "›";

    const reviewBox = document.createElement("a");
    reviewBox.className = "tp-review-text tp-card-link tp-review-lang-host";
    reviewBox.target = "_blank";
    reviewBox.rel = "noopener noreferrer";
    reviewBox.addEventListener("click", function () {
      try {
        const r = reviews[state.index] || {};
        emitWidgetEvent("click_trustpilot", {
          target: "review",
          company_slug: company.slug || "",
          review_id: r.id || "",
          review_user_url: r.user_url || "",
          format: 1,
          index: state.index,
        });
      } catch (e) {}
    });

    const reviewRow = document.createElement("div");
    reviewRow.className = "tp-review-row";

    const title = document.createElement("p");
    title.className = "tp-review-title";

    const bodyP = document.createElement("p");
    bodyP.className = "tp-review-body";

    const meta = document.createElement("div");
    meta.className = "tp-review-meta";

    const state = {
      index: 0,
    };

    const langToggle = setupReviewLangToggle(
      reviewBox,
      function () {
        return reviews[state.index];
      },
      lang,
      title,
      bodyP,
      220,
      ratingStarSrc
    );

    function paint() {
      const r = reviews[state.index];
      if (!r) {
        title.textContent = "";
        bodyP.textContent = "";
        bodyP.style.display = "none";
        meta.textContent = "";
        reviewBox.removeAttribute("href");
        reviewBox.classList.remove("tp-clickable");
        langToggle.reset();
        return;
      }
      langToggle.reset();
      if (r.user_url) {
        reviewBox.href = r.user_url;
        reviewBox.classList.add("tp-clickable");
      } else {
        reviewBox.removeAttribute("href");
        reviewBox.classList.remove("tp-clickable");
      }

      meta.textContent = "";
      const pill = verifiedPill(r.verified);
      if (pill) meta.appendChild(pill);
      const stars = starElements(r.rating || data.avg_rating || 5, { starSrc: ratingStarSrc });
      meta.appendChild(stars);
      if (r.author) {
        const authorEl = document.createElement("span");
        authorEl.className = "tp-review-author";
        authorEl.textContent = r.author;
        meta.appendChild(authorEl);
      }
      if (r.date) {
        const dateEl = document.createElement("span");
        dateEl.className = "tp-review-date";
        dateEl.textContent = formatReviewDate(r.date, lang);
        meta.appendChild(dateEl);
      }
      langToggle.refresh();
    }

    function go(delta) {
      const prev = state.index;
      state.index = clamp(
        state.index + delta,
        0,
        Math.max(0, reviews.length - 1)
      );
      paint();
      if (state.index !== prev) {
        emitWidgetEvent("browse_review", {
          company_slug: company.slug || "",
          format: 1,
          direction: delta > 0 ? "next" : "prev",
          from_index: prev,
          to_index: state.index,
        });
      }
    }

    bindNavPointer(navLeft, function () {
      go(-1);
    });
    bindNavPointer(navRight, function () {
      go(1);
    });

    reviewRow.appendChild(title);
    reviewRow.appendChild(bodyP);
    reviewRow.appendChild(meta);
    reviewBox.appendChild(reviewRow);

    carousel.appendChild(navLeft);
    carousel.appendChild(reviewBox);
    carousel.appendChild(navRight);

    card.appendChild(carousel);
    container.appendChild(card);

    paint();
  }

  function collectReviewChunks(index) {
    const langs = {};
    document.querySelectorAll("script.bonbon-reviews-chunk[data-lang]").forEach(function (s) {
      const lg = s.getAttribute("data-lang");
      if (!lg || !s.textContent) return;
      try {
        var chunk = JSON.parse(s.textContent.trim());
        langs[lg] = {
          format: chunk.format || 1,
          lang: chunk.lang || lg,
          reviews: chunk.reviews || [],
          avg_rating: chunk.avg_rating,
          company: chunk.company || (index && index.company),
        };
      } catch (e) {
        tpLog("chunk parse fout", lg, e);
      }
    });
    return langs;
  }

  function parseReviewsStore() {
    if (_reviewsStoreParsed) return _cachedReviewsStore;
    const single = document.getElementById("bonbon-trustpilot-reviews-data");
    if (single && single.textContent && single.textContent.trim()) {
      try {
        _cachedReviewsStore = JSON.parse(single.textContent.trim());
        _reviewsStoreParsed = true;
        return _cachedReviewsStore;
      } catch (e) {
        tpLog("single parse fout", e);
      }
    }

    const indexEl = document.getElementById("bonbon-trustpilot-reviews-index");
    var index = null;
    if (indexEl && indexEl.textContent && indexEl.textContent.trim()) {
      try {
        index = JSON.parse(indexEl.textContent.trim());
      } catch (e) {
        tpLog("index parse fout", e);
      }
    }

    const langs = collectReviewChunks(index);
    const langKeys = Object.keys(langs);
    if (langKeys.length) {
      _cachedReviewsStore = {
        v: 2,
        company: (index && index.company) || (langs.nl && langs.nl.company) || (langs[langKeys[0]] && langs[langKeys[0]].company),
        company_slug: index && index.company_slug,
        langs: langs,
      };
      _reviewsStoreParsed = true;
      return _cachedReviewsStore;
    }

    if (index && index.langs && !index.split) {
      _cachedReviewsStore = index;
      _reviewsStoreParsed = true;
      return index;
    }

    _cachedReviewsStore = null;
    _reviewsStoreParsed = true;
    return null;
  }

  function tpDebug() {
    return (
      (typeof window !== "undefined" && window.__BONBON_TP_DEBUG__) ||
      document.getElementById("bonbon-tp-debug-panel") ||
      document.querySelector("[data-tp-widget][data-tp-debug='1']")
    );
  }

  function tpLog() {
    if (!tpDebug()) return;
    // eslint-disable-next-line no-console
    console.log.apply(console, ["[BonBon TP]"].concat(Array.prototype.slice.call(arguments)));
  }

  function loadWidgetDataLocal(widgetEl) {
    const lang = widgetEl.getAttribute("data-lang") || detectLangFromPath();
    const format = Number(widgetEl.getAttribute("data-format") || 1);
    var limit = Number(widgetEl.getAttribute("data-limit") || 100);
    if (isNaN(limit) || limit < 0) limit = 100;
    if ((format === 2 || format === 4) && limit < 1) limit = 0;
    const cacheKey = lang + "|" + format + "|" + limit;
    if (_widgetDataByKey[cacheKey]) return _widgetDataByKey[cacheKey];

    const store = parseReviewsStore();
    tpLog("parseReviewsStore", store ? Object.keys(store) : null);
    if (!store) {
      tpLog(
        "geen script-tags:",
        !!document.getElementById("bonbon-trustpilot-reviews-data"),
        !!document.getElementById("bonbon-trustpilot-reviews-index"),
        document.querySelectorAll("script.bonbon-reviews-chunk").length
      );
      return null;
    }
    let payload =
      (store.langs && store.langs[lang]) ||
      store[lang] ||
      (store.langs && store.langs.nl) ||
      store.nl;
    if (!payload) {
      tpLog("geen payload voor lang", lang, "beschikbaar", store.langs ? Object.keys(store.langs) : []);
      return null;
    }
    if (store.v === 2 && store.company && !payload.company) {
      payload = Object.assign({}, payload, { company: store.company });
    }
    const out = Object.assign({}, payload, { format: format, lang: lang });
    tpLog("payload ok", lang, "reviews", (out.reviews || []).length);
    if (limit > 0 && Array.isArray(out.reviews) && out.reviews.length > limit) {
      out.reviews = out.reviews.slice(0, limit);
    }
    if (limit === 0) out.reviews = [];
    _widgetDataByKey[cacheKey] = out;
    return out;
  }

  async function loadWidgetData(widgetEl) {
    const local = loadWidgetDataLocal(widgetEl);
    if (local) return local;
    throw new Error(
      "Lokale review-data ontbreekt in de pagina. Sync op de Pi (shopify-sync) en controleer metafields namespace bonbon_trustpilot. Gebruik sectie TP metafield debug."
    );
  }

  function applyLangTextFormat(format, widgetEl, data) {
    // Placeholder: je kunt hier ook vertaalde labels toevoegen per lang.
    return { format: format };
  }

  function widgetCssUrl(widgetEl) {
    return String(widgetEl.getAttribute("data-widget-css") || "").trim();
  }

  function ensureGlobalWidgetStylesheet(cssUrl) {
    if (!cssUrl || document.querySelector('link[data-tp-widget-global-css="1"]')) return;
    var link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = cssUrl;
    link.setAttribute("data-tp-widget-global-css", "1");
    document.head.appendChild(link);
  }

  function injectInlineWidgetCss(root, cssText) {
    var st = root.querySelector("style[data-tp-widget-css]");
    if (!st) {
      st = document.createElement("style");
      st.setAttribute("data-tp-widget-css", "inline");
      root.appendChild(st);
    }
    st.textContent = cssText;
  }

  function fetchWidgetCssText(cssUrl) {
    if (!cssUrl) return Promise.resolve("");
    if (window.__BONBON_TP_WIDGET_CSS_TEXT__) {
      return Promise.resolve(window.__BONBON_TP_WIDGET_CSS_TEXT__);
    }
    if (_widgetCssFetchByUrl[cssUrl]) return _widgetCssFetchByUrl[cssUrl];
    _widgetCssFetchByUrl[cssUrl] = fetch(cssUrl, { credentials: "omit", cache: "force-cache" })
      .then(function (r) {
        if (!r.ok) throw new Error("HTTP " + r.status);
        return r.text();
      })
      .then(function (css) {
        if (!css || css.indexOf(".tp-widget") < 0) throw new Error("geen widget.css");
        window.__BONBON_TP_WIDGET_CSS_TEXT__ = css;
        return css;
      })
      .catch(function () {
        return "";
      });
    return _widgetCssFetchByUrl[cssUrl];
  }

  function loadShadowStylesheetLink(shadow, cssUrl) {
    return new Promise(function (res) {
      var link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = cssUrl;
      var timer = setTimeout(function () {
        res(false);
      }, 8000);
      link.addEventListener(
        "load",
        function () {
          clearTimeout(timer);
          res(true);
        },
        { once: true }
      );
      link.addEventListener(
        "error",
        function () {
          clearTimeout(timer);
          res(false);
        },
        { once: true }
      );
      shadow.appendChild(link);
    });
  }

  /** Eén gedeelde CSS-fetch per pagina; daarna inline in elke shadow (sneller dan N× link). */
  function loadShadowStyles(shadow, cssUrl) {
    if (!cssUrl) return Promise.resolve(false);
    return fetchWidgetCssText(cssUrl).then(function (css) {
      if (css) {
        injectInlineWidgetCss(shadow, css);
        return true;
      }
      return loadShadowStylesheetLink(shadow, cssUrl);
    });
  }

  function createWidgetMount(root, widgetEl, cssOk) {
    var mount = document.createElement("div");
    mount.className = "tp-widget";
    if (!cssOk) mount.setAttribute("data-tp-css-missing", "1");
    root.appendChild(mount);
    return mount;
  }

  /** Shadow DOM: thema-CSS (Shopify mobiel) kan flex/spacing van formaat 4 breken. */
  function prepareWidgetMount(widgetEl, scriptOrigin) {
    if (widgetEl.__tpMount && widgetEl.shadowRoot) {
      return Promise.resolve(widgetEl.__tpMount);
    }
    var cssUrl = widgetCssUrl(widgetEl);
    ensureGlobalWidgetStylesheet(cssUrl);

    return new Promise(function (resolve) {
      var settled = false;
      function finish(mount) {
        if (settled) return;
        settled = true;
        widgetEl.__tpMount = mount;
        resolve(mount);
      }
      try {
        var n = widgetEl.firstChild;
        while (n) {
          var next = n.nextSibling;
          if (n.nodeType === 1) {
            widgetEl.removeChild(n);
          }
          n = next;
        }
      } catch (eClear) {}
      var shadow;
      try {
        shadow = widgetEl.attachShadow({ mode: "open" });
      } catch (eShadow) {
        loadShadowStyles(document.head, cssUrl).then(function (cssOk) {
          finish(createWidgetMount(widgetEl, widgetEl, cssOk));
        });
        return;
      }

      loadShadowStyles(shadow, cssUrl).then(function (cssOk) {
        finish(createWidgetMount(shadow, widgetEl, cssOk));
      });
    });
  }

  async function init() {
    const script = document.currentScript || document.querySelector('script[data-tp-widget-src="true"]') || document.currentScript;
    const scriptOrigin = script && script.src ? new URL(script.src).origin : window.location.origin;

    parseReviewsStore();
    const widgetsArr = Array.from(document.querySelectorAll("[data-tp-widget]"));
    if (widgetsArr.length && widgetsArr[0]) {
      var cssWarm = widgetCssUrl(widgetsArr[0]);
      if (cssWarm) fetchWidgetCssText(cssWarm);
    }
    widgetsArr.forEach(function (widgetEl) {
      widgetEl.__tpFlagUrls = parseFlagUrls(widgetEl);
      if (!window.__BONBON_TP_FLAG_URLS__ && widgetEl.__tpFlagUrls) {
        window.__BONBON_TP_FLAG_URLS__ = widgetEl.__tpFlagUrls;
      }
      tpLog("vlag-URLs", widgetEl.__tpFlagUrls);
    });
    const mountsAndData = await Promise.all(
      widgetsArr.map(function (widgetEl) {
        return Promise.all([
          prepareWidgetMount(widgetEl, scriptOrigin),
          loadWidgetData(widgetEl).catch(function (e) {
            return { __tpErr: e };
          }),
        ]);
      })
    );

    widgetsArr.forEach(function (widgetEl, idx) {
      const mount = mountsAndData[idx][0];
      const data = mountsAndData[idx][1];
      const brandStarSrc = resolveTrustpilotStarUrl(widgetEl, scriptOrigin);
      const ratingStarSrc = resolveTrustpilotRatingStarUrl(widgetEl, scriptOrigin);
      if (mount.getAttribute("data-tp-css-missing") === "1") {
        var cssHref = widgetCssUrl(widgetEl);
        mount.innerHTML =
          '<div style="color:#b71c1c;font-size:13px;padding:16px;border:1px dashed rgba(183,28,28,.4);line-height:1.5;">' +
          "<strong>widget.css ontbreekt of laadt niet.</strong><br/>" +
          "Upload <code>assets/widget.css</code> naar je Shopify-theme (zelfde map als widget.js) en ververs de preview.<br/>" +
          (cssHref
            ? '<small style="opacity:.85">URL: ' + cssHref.replace(/</g, "&lt;") + "</small>"
            : "") +
          "</div>";
        console.error("[BonBon TP] widget.css niet geladen", cssHref);
        return;
      }
      if (data && data.__tpErr) {
        var errMsg = data.__tpErr && data.__tpErr.message ? String(data.__tpErr.message) : "Onbekende fout";
        mount.innerHTML =
          '<div style="color:#b71c1c;font-size:13px;padding:16px;border:1px dashed rgba(183,28,28,.4);line-height:1.4;">' +
          "Widget-data niet beschikbaar (alleen Shopify-metafields).<br/><small>" +
          errMsg.replace(/</g, "&lt;") +
          "</small></div>";
        widgetEl.style.minHeight = "48px";
        tpLog("fout", errMsg);
        console.error("[BonBon TP]", data.__tpErr);
        return;
      }
      try {
        const format = Number(widgetEl.getAttribute("data-format") || 1);
        if (format === 2) renderFormat2(data, mount, ratingStarSrc);
        else if (format === 3) {
          widgetEl.classList.add("tp-host-format3");
          renderFormat3(data, mount, brandStarSrc, ratingStarSrc);
        } else if (format === 4) {
          widgetEl.classList.add("tp-host-format4");
          renderFormat4(data, mount, brandStarSrc, ratingStarSrc);
        } else renderReviewCarousel(data, mount, ratingStarSrc);
        applyLangTextFormat(format, widgetEl, data);
      } catch (e) {
        mount.innerHTML =
          '<div style="color:#999;font-size:12px;padding:12px;border:1px dashed rgba(0,0,0,.2);">Widget-data niet beschikbaar.</div>';
        // eslint-disable-next-line no-console
        console.error(e);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

